module.exports = __webpack_public_path__ + "static/img/cp_icon_B02.e273a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B02.png
// module id = Nq5b
// module chunks = 1